import React from 'react'
import { getHexColor, TwoColorIconProps } from '../utils'

export const NoPhoneIcon: React.FC<TwoColorIconProps> = ({
  size = 24,
  color1 = 'white',
  color2 = 'black',
  className,
  onClick,
}) => {
  const fill = getHexColor(color1)
  const stroke = getHexColor(color2)
  return (
    <svg
      width={size}
      height={size}
      className={className}
      onClick={onClick}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 23C6.45 23 5.97933 22.8043 5.588 22.413C5.196 22.021 5 21.55 5 21V3C5 2.45 5.196 1.979 5.588 1.587C5.97933 1.19567 6.45 1 7 1H17C17.55 1 18.021 1.19567 18.413 1.587C18.8043 1.979 19 2.45 19 3V21C19 21.55 18.8043 22.021 18.413 22.413C18.021 22.8043 17.55 23 17 23H7ZM7 20V21H17V20H7ZM7 18H17V6H7V18ZM7 4H17V3H7V4Z"
        stroke={fill}
      />
      <path d="M3.75 1.875L22.4669 20.5919" stroke={stroke} strokeWidth="2.25" strokeLinecap="round" />
      <path d="M2.25 3.375L20.9669 22.0919" stroke={fill} strokeWidth="2.25" strokeLinecap="round" />
    </svg>
  )
}
